import React from "react";

import PageTitle from "../../../components/PageTitle";
import Question from "../../../components/Question";
import QuestionDatepicker from "../../../components/QuestionDatepicker";
import QuestionsFrame from "../../../components/QuestionsFrame";

const ExistingOrder: React.FC = () => (
  <>
    <PageTitle
      heading="Original order details"
    />
    <QuestionsFrame>
      <Question name="eo_case_no" />
    </QuestionsFrame>
    <QuestionsFrame>
      <QuestionDatepicker name="eo_aprox_date" />
    </QuestionsFrame>
    <QuestionsFrame>
      <QuestionDatepicker name="eo_expiry" />
    </QuestionsFrame>
  </>
);

export default ExistingOrder;
